import { getLocalizedValue, getLocalizedValues } from "./get-localized-value.js";
import { isPlainObject, isPresent } from "./type-guards.js";
const findAttribute = (input, attrName) => input && input.attributes ? input.attributes.find((attr) => attr.name === attrName) : void 0;
const getAttrValue = (input, attrName) => {
  const attr = findAttribute(input, attrName);
  if (isPlainObject(attr) && attr.value && attr.value.hasOwnProperty("key") && attr.value.hasOwnProperty("label")) {
    return attr.value.label;
  }
  return attr && attr.value;
};
const getLocalizedAttrValue = (input, attrName, locale) => {
  const attr = getAttrValue(input, attrName);
  if (!isPlainObject(attr)) {
    return "";
  }
  return getLocalizedValue(attr, locale);
};
const getLocalizedAttrValues = (input, attrName, locale) => {
  const attr = getAttrValue(input, attrName);
  if (!Array.isArray(attr)) {
    return [];
  }
  return getLocalizedValues(attr, locale);
};
const getJoinedLocalizedAttrValues = (input, attrName, locale, separator = ", ") => {
  const attr = getAttrValue(input, attrName);
  if (isPlainObject(attr)) {
    return getLocalizedValue(attr, locale);
  }
  if (Array.isArray(attr)) {
    return getLocalizedValues(attr, locale)?.join(separator) ?? "";
  }
  return "";
};
const getStringAttrValue = (input, attrName) => {
  const value = getAttrValue(input, attrName);
  if (isPresent(value) && typeof value === "string") {
    return value;
  }
  return void 0;
};
export {
  getAttrValue,
  getJoinedLocalizedAttrValues,
  getLocalizedAttrValue,
  getLocalizedAttrValues,
  getStringAttrValue
};
//# sourceMappingURL=get-attribute.js.map
